var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/textalign-justifycenter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66406 3.33301H13.9974",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.66406 8H13.9974",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.66406 12.667H13.9974",
    stroke: "#919191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.66667 2.66667V4C4.66667 4.36444 4.36444 4.66667 4 4.66667H2.66667C2.30222 4.66667 2 4.36444 2 4V2.66667C2 2.30222 2.30222 2 2.66667 2H4C4.36444 2 4.66667 2.30222 4.66667 2.66667Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.66667 7.33366V8.66699C4.66667 9.03144 4.36444 9.33366 4 9.33366H2.66667C2.30222 9.33366 2 9.03144 2 8.66699V7.33366C2 6.96921 2.30222 6.66699 2.66667 6.66699H4C4.36444 6.66699 4.66667 6.96921 4.66667 7.33366Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.66667 11.9997V13.333C4.66667 13.6975 4.36444 13.9997 4 13.9997H2.66667C2.30222 13.9997 2 13.6975 2 13.333V11.9997C2 11.6352 2.30222 11.333 2.66667 11.333H4C4.36444 11.333 4.66667 11.6352 4.66667 11.9997Z",
    fill: "#919191"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.524c7cda55271c1e90fc1ee4bb513116.svg";
export { ForwardRef as ReactComponent };